export function getCookie(name) {
  var arr,
    reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");

  if (typeof document !== "undefined") {
    arr = document.cookie.match(reg);
    if (arr) {
      return unescape(arr[2]);
    } else {
      return null;
    }
  } else {
    return null;
  }
  // if (typeof document !== "undefined" && arr === document.cookie.match(reg)) return unescape(arr[2]);
  // else return null;
}
